module.exports = __webpack_public_path__ + "img/durocher_svg_V9.9a1d87c3.svg";